"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.performanceWorkbookRequestSchema = exports.PERFORMANCE_VIEWS = void 0;
// J-327 (Louis, 2026-10-23, item 2: "Ability to Export on "Performance" page what is currently filtered into a
// nice workbook"): `POST /performance-workbooks`, the Performance page's selections in the body, as the Gap
// Closure Workbook's POST takes the Quality screen's. The rows come from `practiceTable` or `groupTable`
// (../performance-rows.ts), which the screen uses too, so the file holds exactly what the screen shows.
const zod_1 = require("zod");
const yearSchema = zod_1.z.coerce.number().int().min(2000).max(2100);
const acoCodeSchema = zod_1.z.string().min(1).max(64);
const measureKeySchema = zod_1.z.number().int().positive().max(2_147_483_647);
exports.PERFORMANCE_VIEWS = ["groups", "practices"];
exports.performanceWorkbookRequestSchema = zod_1.z.object({
    year: yearSchema,
    /** The header's ACO; null is "All". */
    aco: acoCodeSchema.nullable(),
    /** Every ACO the screen shows, in its order: the header's one, or each ACO in scope with data. */
    acos: zod_1.z.array(acoCodeSchema).min(1).max(20),
    view: zod_1.z.enum(exports.PERFORMANCE_VIEWS),
    /** The TIN Name view's Performance group choice; omitted is "All". */
    group: zod_1.z.number().int().positive().max(2_147_483_647).optional(),
    sort: zod_1.z
        .object({ measureKey: measureKeySchema, direction: zod_1.z.enum(["ascending", "descending"]) })
        .optional(),
    filter: zod_1.z
        .object({
        measureKey: measureKeySchema.nullable(),
        condition: zod_1.z.enum(["below", "above"]),
        value: zod_1.z.number().min(0).max(100),
    })
        .optional(),
});
//# sourceMappingURL=performance-workbook.js.map